import React from 'react';
import { CTAButton } from './CTAButton';
import { TrustRow } from './TrustRow';
import { OFFER_ANCHOR, PRODUCT_ALT, PRODUCT_IMG } from './constants';
export function Hero() {
  return <section className="bg-pf-cream px-3 pb-2 pt-3 sm:px-4" data-id="element-98" data-mp="9kjvumdkz02m">
      <div className="mx-auto max-w-3xl text-center" data-id="element-99" data-mp="9l33na9io82x">
        <h1 className="mb-1.5 font-display text-[24px] font-extrabold uppercase leading-[1.03] tracking-tight text-pf-navy sm:text-[42px]" data-id="element-100" data-mp="4mi319qcrmdy">
          The Complete Ready-to-Use System for{' '}
          <span className="text-pf-coral" data-id="element-101" data-mp="x9uspsrt8abh">Prenatal Fitness Coaches</span>
        </h1>
        <p className="mx-auto mb-1 max-w-2xl text-[13px] font-medium leading-snug text-pf-ink sm:text-base" data-id="element-102" data-mp="sb1ajn1kvv4z">
          Stop spending hours searching for exercises, rebuilding sessions, and wondering how to
          adapt every workout as your clients’ needs change.
        </p>
        <p className="mx-auto mb-1.5 max-w-2xl text-[13px] font-bold leading-snug text-pf-navy sm:text-base" data-id="element-103" data-mp="3cz5uuafyvxzt">
          Get the complete professional system to assess, plan, adapt, and coach prenatal fitness
          sessions with ready-to-use resources at your fingertips.
        </p>

        <a href={OFFER_ANCHOR} className="mb-1.5 block" aria-label="Go to the purchase section" data-id="element-104" data-mp="3o5j41cky9nmv">
          <img src={PRODUCT_IMG} alt={PRODUCT_ALT} className="mx-auto w-full max-w-[260px] object-contain drop-shadow-2xl transition-transform duration-200 ease-out hover:scale-[1.02] sm:max-w-sm" data-id="element-105" data-mp="39cflp2zjb5v3" />
        </a>

        <CTAButton className="mx-auto mb-1.5 max-w-md" data-id="element-106" data-mp="358zu4l2bnvp9">
          🤰 YES! I WANT THE COMPLETE SYSTEM
        </CTAButton>

        <TrustRow showAccess={false} guaranteeLabel="🛡️ 14-Day Money-Back Guarantee — Zero Risk" data-id="element-107" data-mp="2qlenwia5hgd4" />
      </div>
    </section>;
}